import gql from 'graphql-tag'

const createOrUpdateEducationMutation = gql`
  mutation createOrUpdateEducations($expertId: String!, $input: [EducationInput!]!) {
    createOrUpdateEducations(expertId: $expertId, input: $input) {
      newEntities {
        ... on Education {
          id
        }
      }
      updatedEntities
    }
  }
`

export default createOrUpdateEducationMutation
